import Th from "@/components/Table/Th";
import { table_head } from "../maintainers.module.scss";

import { table_titles } from "./codes.constants";

const AptitudesTableHead = ({ order, setOrder, orderType, setOrderType }) => {
	return (
		<thead className={table_head}>
			<tr>
				{table_titles &&
					table_titles.map((title, i) => {
						return (
							<Th
								key={i}
								item_name={title.name}
								item_size={title.size}
								item_order={title.order}
								order={order}
								setOrder={setOrder}
								orderType={orderType}
								setOrderType={setOrderType}
								item_class={title.class}
								only_admin={title.only_admin}
								border_color={"0.5px solid #7fb02f"}
							></Th>
						);
					})}
			</tr>
		</thead>
	);
};

export default AptitudesTableHead;
